'use strict';

const stateCode = {
  success: 1000,       // 正常返值
  exception: 1001,     // 服务异常
  signError: 1002,     // 签名未通过
  rollback: 1003,     // 事务回滚
  dataError: 1004,     // 数据异常

};


module.exports = stateCode;



// WEBPACK FOOTER //
// ./src/utils/stateCode.js